// IE 2026 10 08 / ODOO-5800: ширина колонки грида, которую запоминаем после ресайза мышью (AttrGrid.resizedColumn → set_width / rhCol_setWidth).
// wijmo при ресайзе ставит колонке СЫРОЙ размер (_MouseHandler._SZ_MIN = 0): правый край заголовка утянули левее левого — col.width = 0,
// левее minWidth — 1…24; а рисует колонку не уже minWidth (renderWidth прижат к minWidth). Сохранённый 0 при пересборке колонок
// после Save читается как «ширины нет» (if (width0)) → автоширина: узкая колонка снова становилась широкой.
// Запоминаем ВИДИМУЮ ширину: renderWidth (его уже прижал wijmo), иначе сырую; не меньше minWidth колонки (нет — 25, как col.minWidth
// по умолчанию в AttrGrid). Чтение сохранённой ширины не меняется: старые нули в записях остаются автошириной.

export const GRID_COL_MIN_WIDTH = 25

// col: { width, renderWidth, minWidth } — колонка wijmo (или такой же объект) → целое число px, не меньше минимума
export function gridColWidth_visible(col) {
    const min = Number(col?.minWidth) > 0 ? Number(col.minWidth) : GRID_COL_MIN_WIDTH
    const rw = Number(col?.renderWidth)
    const w = rw > 0 ? rw : Number(col?.width)
    return Math.round(Math.max(Number.isFinite(w) ? w : 0, min))
}

// IE 2026 10 08 / ODOO-5800: минимум ширины первой видимой колонки грида-дерева (AttrGrid.ensureTreeColMinWidth): кнопка разворота ~20px + зазор
// и отступ treeIndent (нет — 14) на каждый уровень до самого глубокого уровня с детьми. Нет уровней с детьми — 0 (минимума нет).
// Это и minWidth колонки: мышью уже не сузить, иначе сохранялась ширина, которую страж после Save снова поднимал (Rule type: 25 → 54).
export function gridTreeCol_need(treeIndent, maxLevel) {
    const lv = Number(maxLevel)
    if (!(lv > 0)) return 0
    const ind = Number(treeIndent) > 0 ? Number(treeIndent) : 14
    return ind * lv + 26
}
